import { Component, Input, ViewChild, ViewRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ModalController, NavController, Platform, } from "@ionic/angular";
// import { SwiperComponent } from 'swiper/angular'; //angular-material-swiper
// import { register } from 'swiper/element/bundle';
import { TournamentService } from "../../../../gamer/services/tournament.service";
import { IActivity, LineUpService, TshirtType } from "../../../services/lineup-service";
import { activities } from "../../../services/lineup-service";
import { Router } from "@angular/router";
import { NavigationService } from "src/providers/navigation/navigation.service";
// register();
@Component({
    selector: "toolbar-settings",
    templateUrl: "toolbar-settings.html",
    styleUrls:['./toolbar-settings.scss']
})
export class SettingsComponent {
    activeTeam: number = 0;
    activePlan: number = 0;
    activeTshirtType: TshirtType = TshirtType.tshirt;
    headerCss: boolean = false;
    activities = activities;
    $activity;
    autoSliding: boolean = false;
    routerState:any;
    previousUrl:string;
    pagination = { clickable: true };

    // @ViewChild('slides') slider: Slides; 
    @ViewChild('slider', { static: false }) slider: any;

    constructor(
        private router:Router,
        public ls: LineUpService,
        public navCtrl: NavController,
        public gs: TournamentService,
        private platform: Platform,
        public translate: TranslateService,
        private navService:NavigationService
    ) {
        const nav = this.router.getCurrentNavigation();
        this.routerState = nav?.extras?.state || {};
        this.uiAdopter();
        this.previousUrl = this.navService.getPreviousUrl();
    }

    uiAdopter() {
        if (this.platform.is('ios')) {
            this.headerCss = true;
        }
    }

    ionViewDidEnter() {
        this.activeTeam = this.routerState['activeTeam'];
        this.activePlan = this.routerState['activePlan'];
        this.$activity = this.ls.field.activity;
        this.activeTshirtType = this.ls.field.type;
        setTimeout(() => {
            this.autoSliding = true;
        }, 200);
    }

    clickTest(activeTshirtType, i){
        console.log('a=' + activeTshirtType + ', i=' + i)
    }

    slideChange(event) {
        console.log('event: ', event);
        if(this.autoSliding){
            let i = this.slider.swiper.activeIndex;
            // let i = event.target.swiper.activeIndex;
            console.log('i: ', i - 2);
            console.log(this.types[this.filter(i - 2)]);
            this.activeTshirtType = this.ls.field.type = this.filter(this.slider.swiper.activeIndex - 2);
            console.log('this.activeTshirtType: ', this.activeTshirtType);
            this.ls.save();
        }
    }

    filter(n: number){
        switch(n){
            case -2: return 7;
            case 10: return 1;
            default:
            return n;
        }
    }

    onWindowClose() {
        this.gs.setActivity(this.$activity, this.activePlan, this.activeTeam);
        this.ls.field.activity = this.$activity;
        this.ls.save();
        this.ls.saveDisplayConfigs();
        this.ls.updateSub.next(true);
        this.navCtrl.pop();
    }

    onThreeChange() {
        document.documentElement.style.setProperty('--threeD', this.ls.field.threeD ? "45deg" : "0");
        this.ls.updateSub.next(true);
    }

    types = [
        this.translate.instant('bandedcollar'),
        this.translate.instant('henley'),
        this.translate.instant('hoodie'),
        this.translate.instant('longsleeves'),
        this.translate.instant('nosleeves'),
        this.translate.instant('polo'),
        this.translate.instant('shirt'),
        this.translate.instant('tshirt'),
        this.translate.instant('vneck')
    ]
}